import { DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import { Button, Modal, message } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { PDFViewer } from '../../components/design/PDFviewer';
import { getFilePath, getPreviewUrl, isShowable } from "../../library/constants";
import style from './received-artwork.module.scss';

const DocumentsDownloader = ({ image, name, comment, project_id, itemId, containerStyles }) => {
    const [isModalOpen, setisOpen] = useState(false)
    return (
        <div className={style.itemDetail} style={containerStyles}>
            <img src={getPreviewUrl(image, project_id, itemId)} className={style.imageBox} />
            <div className={style.imageName}>
                <h4>{name}</h4>
                {comment != undefined && <p style={{width:'50vw' , wordWrap:'break-word'}}><b>Comment</b> : {comment}</p>}
            </div>
            <div className={style.bottomButton}>
                <Link reloadDocument to={getFilePath(image, project_id, itemId)} download="image.png"> <Button icon={<DownloadOutlined />} >Download</Button> </Link>
                <Button icon={<EyeOutlined />} onClick={() => { isShowable(image) ? setisOpen(true) : message.warning('Not Previewable') }}>View</Button>
            </div>
            <Modal title="Preview" open={isModalOpen} onCancel={() => { setisOpen(false) }} footer={<Button onClick={() => { setisOpen(false) }} >Close</Button>}>
                <PDFViewer item_id={itemId} path={image} project_id={project_id} type={image.split('.').pop()} />
            </Modal>
        </div>
    )
}

DocumentsDownloader.propTypes = {
    image: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    comment: PropTypes.string,
    project_id: PropTypes.number,
    itemId: PropTypes.number,
    containerStyles: PropTypes.object,
}

export default DocumentsDownloader